.backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  inset-inline-start: 0;
  inset-inline-end: 0;

  z-index: 15;

  background-color: rgba(0, 0, 0, 0.6);

  backdrop-filter: blur(4px) opacity(80%);
  -webkit-backdrop-filter: blur(4px) opacity(80%);

  padding: 20px;

  overflow-y: auto;
  overflow-x: hidden;

  opacity: 1;
  visibility: visible;

  display: flex;
  justify-content: center;

  pointer-events: all;

  transition:
    opacity var(--trans-time) var(--trans-func),
    visibility 0s;
}
@media screen and (min-width: 768px) {
  .backdrop {
    padding: 32px;
  }
}

.backdrop_hidden {
  composes: backdrop;

  opacity: 0;
  visibility: hidden;

  transition:
    opacity var(--trans-time) var(--trans-func),
    visibility 0s var(--trans-delay);

  pointer-events: none;
}

.modal {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  border-radius: 12px;

  background-color: var(--Neutral-white, #fff);
  box-shadow: 0 1px 12px 0 rgba(25, 27, 35, 0.15);

  padding: 32px 20px;

  width: 100%;
  max-width: 430px;

  margin-top: auto;
  margin-bottom: auto;

  transform: scale(1);

  transition: transform var(--trans-time) var(--trans-func);

  position: relative;
}
@media screen and (min-width: 768px) {
  .modal {
    padding: 40px;

    width: 500px;
    max-width: 500px;
  }
}

.modal_hidden {
  composes: modal;

  transform: scale(0.5);
}

.btn_close {
  position: absolute;
  top: 12px;
  inset-inline-end: 12px;

  composes: btn-icon from global;
}

.btn_close > img {
  height: 16px;
}
